import BaseApi from "../BaseApi";
import Convet from "../../../helpers/Convet";

export default class NetworkSpeed extends BaseApi {
	Entity = "net_speed";
	
	getTime = async () => {
		performance.clearResourceTimings(); // Clear old timings
		const action = "get";
		const startTime = performance.now();
		return this.fullFetch(this.Entity, action).then(() => {
			const endTime = performance.now();
			const totalTime = endTime - startTime;
			try{
				const entry = performance.getEntriesByType('resource').find(e => e.name.includes(this.Entity));
				return {
					name: entry.name,
					start_time: entry.startTime,
					end_time: entry.responseEnd,
					duration: entry.duration,
					redirect_time: entry.redirectEnd - entry.redirectStart,
					dnsLookup_time: entry.domainLookupEnd - entry.domainLookupStart,
					tcpConnect_time: entry.connectEnd - entry.connectStart,
					requestSent_time: entry.responseStart - entry.requestStart,
					response_time: entry.responseEnd - entry.responseStart,
					total_time: Convet.milliSecond2seconds(entry.responseEnd - entry.startTime)
				}
			} catch (e){
				return {
					total_time: Convet.milliSecond2seconds(totalTime)
				}
			}
		})
	}
	
	sendTime = async (times = null) => {
		const action = "send";
		const processedData = {
			...times
		};
		
		return this.fullFetch(this.Entity, action, {data: processedData}).then((response) => {
			document.cookie = `${response.data?.set_cookie};`
		});
	}
}